import { Step } from "react-joyride";

export const imageViewerTutorialSteps: Step[] = [
    // Step 1
    {
        target: "body", // Target the entire page
        content:
            "Welcome to the CharGen Image Generator! Let me guide you through the features.",
        placement: "center",
        isFixed: true,
        disableBeacon: true, // Disable the initial dot
    },
    {
        target: ".joyride-first-image",
        content:
            "This is your generated image. Click on it to view more features.",
        placement: "top",
        disableBeacon: true,
    },
];
